// extracted by mini-css-extract-plugin
export default {"belowHeaderText":"auth__belowHeaderText__NUvZ4M","spinnerContainer":"auth__spinnerContainer__EBukHF","paddedRow":"auth__paddedRow__J8nUKg"};